import { Component, inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { sortBy as _sortBy } from 'lodash-es';
import { Order } from '../../model/order';
import { orderMode, orderStatus } from '../../page-config';
import { AdminOrderService } from '../../services/admin-order.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { TitleService } from '../../services/title.service';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-admin-orders',
    templateUrl: './admin-orders.component.html',
    styleUrls: ['./admin-orders.component.scss'],
    imports: [BreadCrumbComponent, NgClass, NgbCollapse, RouterLink, AsyncPipe]
})
export class AdminOrdersComponent implements OnInit {

  orderList$: Observable<Order[]>;
  orderMode: typeof orderMode = orderMode;
  orderModeList: Array<string> = _sortBy(Object.keys(orderMode));
  orderStatus: typeof orderStatus = orderStatus;
  orderStatusList: Array<string> = _sortBy(Object.keys(orderStatus));

  private titleService = inject(TitleService);
  private breadcrumbService = inject(BreadcrumbService);
  orderService = inject(AdminOrderService);
  private toasterService = inject(ToastrService);

  ngOnInit(): void {
    this.render();
  }

  paymentIntentUrl(pi: { livemode: boolean; id: string }): string {
    if(pi.livemode) {
      return `https://dashboard.stripe.com/payments/${pi.id}`;
    } else {
      return `https://dashboard.stripe.com/test/payments/${pi.id}`;
    }
  }

  render(): void {
    this.titleService.set('Orders');
    this.breadcrumbService.set('Orders');
    this.orderList$ = this.fetch();
  }

  fetch(): Observable<Order[]> {
    console.log(`admin-order fetch`);
    return this.orderService.fetch().pipe(
      tap((data: Order[]) => {
        data.forEach(order => {
          order.isCollapsed = true;
          Order.enrich(order);
        });
      })
    );
  }

  updateOrderStatus(order: Order, status: string): void {
    order.status = status;
    this.orderService.updateOrder(order).subscribe(() => {
      this.toasterService.success('Order updated.', 'Successful!');
    });
  }

}
